import { registry, instancePerContainerCachingFactory } from 'tsyringe';
import {
  kNameOfNotificationWindowService,
  INotificationWindowService,
} from 'app-core/src/interfaces/notification-window-service.interface';
import {
  kNameOfTesterWindowService,
  ITesterWindowService,
} from 'app-core/src/interfaces/tester-window-service.interface';
import {
  kNameOfUserActionService,
  IUserActionService,
} from 'app-core/src/interfaces/user-action-service.interface';

import { NotificationWindowService } from 'app-core/src/services/notification-window.service';
import { TesterWindowService } from '../services/tester-window.service';
import { UserActionService } from 'app-core/src/services/user-action.service';
import { IExposableService } from 'app-core/src/interfaces/exposable-service.inteface';
import { kDITokenExternalService } from '../services/external-services-exposer.service';

// -----------------------------------------------------------------------------
// This is were we register all the external services - i.e. services we want
// other windows to be able to access (yet not have to create an actual
// instance for them).
@registry([
  {
    token: kNameOfNotificationWindowService,
    useFactory: instancePerContainerCachingFactory<INotificationWindowService>(
      (c) => {
        return c.resolve(NotificationWindowService);
      },
    ),
  },
  {
    token: kNameOfTesterWindowService,
    useFactory: instancePerContainerCachingFactory<ITesterWindowService>(
      (c) => {
        return c.resolve(TesterWindowService);
      },
    ),
  },
  {
    token: kNameOfUserActionService,
    useFactory: instancePerContainerCachingFactory<IUserActionService>((c) => {
      return c.resolve(UserActionService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfNotificationWindowService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfTesterWindowService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfUserActionService);
    }),
  },
])
export class ExternalServicesRegistry {}
